import React from "react";
import axios from "axios";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import NavBar2 from "../../components/navigation/NavBar2";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Moment from "react-moment";
import { styles } from "./ProductsPageStyles.js";
import moment from "moment";
const apiBaseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3000";

const drawerWidth = 200;
Moment.globalProductat = "MMM D YYYY";

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      rowsPerPage: 10,
      products: [],
      firstLoadAttempted: false,
    };
  }

  changeNav = (name) => (event) => {
    let path = `/${this.props.match.params.org}/${name}`;
    this.props.history.push(path);
  };

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  componentDidMount() {
    console.log(this.state);
    this.fetchProducts(1, 10);
  }

  nextPage = (event) => {
    this.fetchProducts(
      Number(this.state.page) + 1,
      Number(this.state.rowsPerPage)
    );
    this.setState({
      page: this.state.page + 1,
    });
  };

  previousPage = (event) => {
    this.fetchProducts(
      Number(this.state.page) - 1,
      Number(this.state.rowsPerPage)
    );
    this.setState({
      page: this.state.page - 1,
    });
  };

  deleteProduct = (productId, productName) => {
    var self = this;
    console.log(productId);
    if (
      window.confirm(
        `Are you sure you want to delete the product ${productName}`
      )
    ) {
      axios({
        method: "delete",
        url: `${apiBaseUrl}/v1/org/products/${productId}`,
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
        .then(function (response) {
          console.log(response.data);
          if (response.status === 200) {
            self.fetchProducts();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.setState({ messageError: "Error retrieving products" });
        });
    }
  };

  fetchProducts = (page, per_page) => {
    var self = this;
    axios({
      method: "get",
      url: `${apiBaseUrl}/v1/org/products/get/list?page=${page}&per_page=${per_page}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    })
      .then(function (response) {
        console.log(response.data);
        if (response.status === 200) {
          self.setState({
            products: response.data,
            finished: true,
            firstLoadAttempted: true,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        self.setState({
          messageError: "Error retrieving products",
          firstLoadAttempted: true,
        });
      });
  };

  render() {
    const { classes, ...other } = this.props;
    const products = [];

    for (let product of this.state.products) {
      let plans = "";
      if (product.plans) {
        plans = product.plans.length;
      }

      products.push(
        <TableRow key={product._id}>
          <TableCell>{product.name}</TableCell>
          <TableCell>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              href={`/products/${product.id}`}
            >
              Manage
            </Button>
          </TableCell>
          <TableCell>{plans}</TableCell>
          <TableCell>{product.type}</TableCell>
          <TableCell>
            {moment(new Date(product.created)).format("MM/DD/YYYY")}
          </TableCell>
        </TableRow>
      );
    }

    return (
      <NavBar2 header="Products" {...this.props}>
        {this.state.firstLoadAttempted ? (
          <div>
            {products.length > 0 ? (
              <div>
                <Paper>
                  <AppBar position="static">
                    <Toolbar>
                      <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.grow}
                      >
                        Products - Create or manage your products.
                      </Typography>
                      <Button
                        variant="outlined"
                        color="inherit"
                        href="/products/product/new"
                      >
                        Create a Product
                      </Button>
                    </Toolbar>
                  </AppBar>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Product Name</TableCell>
                        <TableCell>View/Edit</TableCell>
                        <TableCell>Plans</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Created At</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{products}</TableBody>
                    <TableFooter>
                      <TableRow>
                        <TableCell>Page {this.state.page}</TableCell>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell>
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={(event) => this.previousPage(event)}
                            className={classes.paginationButton}
                            disabled={this.state.page <= 1}
                          >
                            Previous
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={(event) => this.nextPage(event)}
                            className={classes.paginationButton}
                            disabled={this.state.products.length < 10}
                          >
                            Next
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </Paper>
              </div>
            ) : (
              <div>
                <Grid container justify={"center"}>
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        className={classes.media}
                        image="/static/images/cards/contemplative-reptile.jpg"
                        title="Contemplative Reptile"
                      />
                      <CardContent>
                        <Typography
                          gutterBottom
                          variant="headline"
                          component="h2"
                        >
                          You don't have a product yet!
                        </Typography>
                        <Typography component="p">
                          Products tell Stripe and Instapayments how much you
                          want to charge and how often.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Button
                        variant="contained"
                        color="primary"
                        href="/products/product/new"
                      >
                        Create a Product
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </div>
            )}
          </div>
        ) : (
          <Grid container justify={"center"}>
            <div className={classes.loader}>
              <CircularProgress size={100} className={classes.progress} />
            </div>
          </Grid>
        )}
        <Button
          variant="fab"
          color="primary"
          aria-label="Add"
          href="/products/product/new"
          className={classes.fab}
        >
          <AddIcon />
        </Button>
      </NavBar2>
    );
  }
}

/*PaperSheet.propTypes = {
  classes: PropTypes.object.isRequired,
};*/

export default withStyles(styles)(Products);
